import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useSelector, shallowEqual } from "react-redux";
import { addProblem } from "../../_redux/patientService";
import { useRxCollection } from "rxdb-hooks";

export const AllergiesDetail = () => {
  const { patientId } = useParams();
  const collection = useRxCollection("allergies");
  const [result, setResult] = useState([]);

  const { user } = useSelector(
    ({ auth }) => ({
      user: auth.user,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (collection) {
      // collection.getAllergies(patientId, user.practice.id, (result) =>
      //   setResult(result)
      // );
    }
  }, [patientId, collection]);

  const onAddAllergy = () => {
    const allergy = {
      code: "21069002",
      code_type: "snomed",
      id: "619514",
      name: "Lipotropic Agent",
      reaction: "Chills",
      reaction_code: "43724002",
      reaction_type: "allergy",
      severity: "mild",
      severity_code: "255604002",
      status_type: "active",
      updated: "2022-02-04 00:16:29",
    };
    addProblem({
      collection: "allergies",
      pid: result[0].pid,
      allergy: allergy,
    }).then((data) => {
      console.log(data);
    });
  };

  return (
    result && (
      <div className="sm:px-6 w-full">
        <div className="bg-white py-4 md:py-7 px-4 md:px-8 xl:px-10"></div>
        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded" onClick={() => onAddAllergy()}>Add Allergies</button>
        <div className="mt-7 overflow-x-auto">
          <table className="w-full whitespace-nowrap">
            <tbody>
              <tr className="focus:outline-none h-16 border border-gray-100 rounded">
                <td className="">
                  <div className="flex items-center pl-5">
                    <p className="text-base font-medium leading-none text-black mr-2">
                      Allergies
                    </p>
                  </div>
                </td>
                <td className="pr-24">
                  <div className="flex justify-end">
                    <p className="text-base font-medium leading-none text-black ml-2">
                      Onset Date
                    </p>
                  </div>
                </td>
              </tr>
              {result &&
                result.length &&
                result[0]?.allergies.map((allergy) => {
                  return (
                    <tr
                      key={allergy.id}
                      className="focus:outline-none h-16 border border-gray-100 rounded"
                    >
                      <td className="">
                        <div className="flex items-center pl-5">
                          <p className="text-base font-medium leading-none text-gray-700 mr-2">
                            {allergy.name}
                          </p>
                        </div>
                      </td>
                      <td className="pr-24">
                        <div className="flex justify-end">
                          <p className="text-sm leading-none text-gray-600 ml-2">
                            {moment(allergy.updated).format("MM/DD/YYYY")}
                          </p>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    )
  );
};
